import { render } from "./PastOrders.vue?vue&type=template&id=061d58c6"
import script from "./PastOrders.vue?vue&type=script&lang=js"
export * from "./PastOrders.vue?vue&type=script&lang=js"

import "./PastOrders.vue?vue&type=style&index=0&id=061d58c6&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__